import React, { useState } from 'react';
import { updateLineItemQuantity, addLineItem, getOrderMetaData } from '@bold-commerce/checkout-frontend-library';
import { getUpdatedApplicationState } from 'src/library';
import { useDispatch } from 'react-redux';
import { useCartSummary } from 'src/hooks';

interface Product {
  title: string;
  price: number;
  variant_id: number;
  image_url: string;
  sku: string;
}

interface UpsellWidget {
  headerText: string;
  products: Product[];
}

function getUpsellProducts(bold_cart_params: any): UpsellWidget {
  console.log({ bold_cart_params })
  const upsellItems = bold_cart_params?.coalition_meta_fields?.upsell?.products;
  const headerText = bold_cart_params?.coalition_meta_fields?.upsell?.headerText;
  if (Array.isArray(upsellItems) && upsellItems.length > 0) {
    const products = upsellItems.map((item: any) => ({
      title: item.title,
      price: item.price,
      variant_id: item.variant_id,
      image_url: item.image_url,
      sku: item.sku,
    }));
    // Use data from bold_cart_params
    return {
      products,
      headerText
    }
  } else {
    // Return static data
    return {
      headerText: 'Customers Also Liked',
      products: [
        {
          title: "Diamond Heart Necklace",
          price: 499.99,
          variant_id: 897,
          image_url:"https://cdn11.bigcommerce.com/s-e3gxtkmyd6/product_images/attribute_rule_images/156_thumb_1684518156.jpg",
          sku: "V-211408505-Yellow-Gold",
        },
        {
          title: "Gold Hoop Earrings",
          price: 479.0,
          variant_id: 348,
          image_url:
            "https://cdn11.bigcommerce.com/s-6zxwqfxnog/products/562/images/560/V-393619200_0_800__58317.1678494895.386.513.jpg?c=1",
          sku: "test earrings",
        },
        {
          title: "Fine Jewelry Cleaner",
          price: 6.99,
          variant_id: 638,
          image_url:
            "https://cdn11.bigcommerce.com/s-6zxwqfxnog/products/813/images/815/logo-removed__91203.1678857563.386.513.png?c=1",
          sku: "test-cleaner",
        },
      ]
    };
  }
}



export function BuyNowUpsellWidget(props: any): React.ReactElement {
  const dispatch = useDispatch();
  const { lineItems } = useCartSummary();

  const [isAddingToCart, setIsAddingToCart] = useState({});
  const [cartItems, setCartItems] = useState<Product[]>([]);
  const [statusMessage, setStatusMessage] = useState('');

  const cartParams = getOrderMetaData()

  const { products, headerText }: UpsellWidget = getUpsellProducts(cartParams.cart_parameters);
  const addItemToCart = async (product_array_index) => {
    console.log('adding to cart...')
    setIsAddingToCart({ ...isAddingToCart, [product_array_index]: true });
    setStatusMessage('');

    const product = products[product_array_index];
    const identicalLineItems = lineItems.filter(item => item.product_data.sku == product.sku);
    // If already in the cart, update only the quantity
    if (identicalLineItems.length > 0) {
      await updateLineItemQuantity(identicalLineItems[0].product_data.line_item_key, identicalLineItems[0].product_data.quantity + 1);
    } else {
      const requestBody = {
        sku: product.sku,
        line_item_key: `${Date.now()}`,
        quantity: 1
      };

      console.log('requestBody', requestBody);

      await addLineItem(requestBody);
    }

    await dispatch(getUpdatedApplicationState)
      .then(() => {
        setIsAddingToCart({ ...isAddingToCart, [product_array_index]: false });
        if (product) {
          setStatusMessage(`${product.title} has been added to cart!`)
          setCartItems([...cartItems, product]);
        }

      });
  };

  return (
    <div className="upsell-widget-wrapper">
      <h3 className="field-section__heading">{headerText}</h3>
      {
          statusMessage &&
          <div className="upsell-widget-status-message-wrapper">
              <p>{statusMessage}</p>
          </div>
      }
      <div className="recommended-products-wrapper">
        {products &&
          products.map((product, index) => (
            <div key={product.sku} className="recommended-product-card">
              <div className="buy-now-up-sell-product-image-container">
                <img className="buy-now-up-sell-product-card-img" src={product.image_url} alt={product.title} />
              </div>
              <div className='recommended-products-info' style={{ textAlign: 'center' }}>
                <p>{product.title}</p>
                <p>${product.price.toFixed(2)}</p>
              </div>
              <div className="buy-now-up-sell-product-card-button-container">
                <button
                  className="recommended-product-add-to-cart"
                  onClick={async () => await addItemToCart(index)}
                  disabled={isAddingToCart[index]}
                >
                  {isAddingToCart[index] ? "Adding To Cart..." : "Add to Cart"}
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
